import { LogLevel } from "@azure/msal-browser";
import { getVideoApiBaseUrl } from "../config/apiBaseUrlsConstants";

// Browser check variables
const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const msedge = ua.indexOf("Edge/");
const msedgeChromium = ua.indexOf("Edg/"); // Modern Edge (Chromium-based)
const firefox = ua.indexOf("Firefox");
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0 || msedgeChromium > 0; // Support both old and new Edge
const isFirefox = firefox > 0;

export const b2cPolicies = {
  names: {
    signUpSignIn: "B2C_1_signupsignin",
    editProfile: "B2C_1_ProfileEditPolicy",
  },
  authorities: {
    signUpSignIn: {
      authority:
        "https://rads4vet.b2clogin.com/rads4vet.onmicrosoft.com/B2C_1_signupsignin",
    },
    editProfile: {
      authority:
        "https://rads4vet.b2clogin.com/rads4vet.onmicrosoft.com/B2C_1_ProfileEditPolicy",
    },
  },
  authorityDomain: "rads4vet.b2clogin.com",
};

const isProduction = process.env.NODE_ENV === "production";

export const msalConfig = {
  auth: {
    clientId: isProduction
      ? "9cd492dc-bbfc-4f16-ac92-073d13d90c5d"
      : "be6df35d-8a05-4630-82b3-7bafa0eae3aa",
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    // For non-Wix flow on localhost: ensure http://localhost:3000/ is added as a redirect URI in Azure AD B2C for the dev clientId above.
    redirectUri: isProduction
      ? "https://app.medilis.ai/"
      : "http://localhost:3000/",
    postLogoutRedirectUri: isProduction
      ? "https://app.medilis.ai/"
      : "http://localhost:3000/",
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: isIE || isEdge || isFirefox,
  },
  system: {
    allowPlatformBroker: false,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: [
    "openid",
    "profile",
    `https://rads4vet.onmicrosoft.com/rads4vet-webapi/api.read`,
  ],
};

export const apiConfig = {
  scopes: [`https://rads4vet.onmicrosoft.com/rads4vet-webapi/api.read`],
  uri: `https://rads4vet.b2clogin.com/rads4vet.onmicrosoft.com`,
};

export const socketConfig = {
  url: isProduction
    ? "https://live-dictation-backend-103412446523.us-east4.run.app"
    : "https://live-dictation-backend-103412446523.us-east4.run.app",
  options: {
    path: "/socket.io",
    transports: ["websocket"],
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
  },
};

/** MedClip screen recording extension (CRE users only). Edge store not published yet. */
export const medClipExtensionConfig = {
  chrome: {
    storeUrl:
      "https://chromewebstore.google.com/detail/medclip/fefagpefpblaphbiielidojpikgfdbfd",
  },
  edge: {
    extensionId: "pepbcmgffhajibcgikfccmeebpcmdpii",
    storeUrl: null,
  },
  getExtensionUrl: () => {
    if (isEdge) {
      return null;
    }
    return medClipExtensionConfig.chrome.storeUrl;
  },
};

export const extensionConfig = {
  // Chrome extension ID and URL
  chrome: {
    extensionId: "lhggkgnkfbkedopafbkblpdalokclejj",
    storeUrl:
      "https://chromewebstore.google.com/detail/zikaron/lhggkgnkfbkedopafbkblpdalokclejj",
  },
  // Edge extension ID and URL
  edge: {
    extensionId: "afhgclakmgpkefpgfpnojpgfibdplcce",
    storeUrl:
      "https://microsoftedge.microsoft.com/addons/detail/zikaron/afhgclakmgpkefpgfpnojpgfibdplcce",
  },
  // Get the appropriate extension URL based on current browser
  getExtensionUrl: () => {
    if (isEdge && extensionConfig.edge.storeUrl) {
      return extensionConfig.edge.storeUrl;
    }
    return extensionConfig.chrome.storeUrl;
  },
  // Get the appropriate extension ID based on current browser
  getExtensionId: () => {
    if (isEdge && extensionConfig.edge.extensionId) {
      return extensionConfig.edge.extensionId;
    }
    return extensionConfig.chrome.extensionId;
  },
};

export const videoApiConfig = {
  baseUrl: getVideoApiBaseUrl(),
  endpoints: {
    getClientAccessUri: "/getClientAccessUri",
    getVideos: "/getVideos",
    deleteVideos: "/deleteVideos",
  },
};

export const twilioConfig = {
  /**
   * Twilio Conversations proxy URL.
   * For local development: Set REACT_APP_TWILIO_PROXY_URL in .env (e.g. http://localhost:3000)
   * For production: Uses socketConfig.url (same backend as Socket.IO)
   */
  proxyUrl: isProduction
    ? socketConfig.url
    : socketConfig.url,
  get apiBase() {
    return `${this.proxyUrl}/api/twilio`;
  },
  endpoints: {
    token: "/token",
    conversation: "/conversation",
    sendInvite: "/send-invite",
    sendWhatsAppMessage: "/send-whatsapp-message",
    listContentTemplates: "/list-content-templates",
    inviteTemplatePreview: "/invite-template-preview",
    webhook: {
      message: "/webhook/message",
      conversation: "/webhook/conversation",
      test: "/webhook/test",
    },
  },
};
